<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup lite_tree" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="show = false"></div>
            </div>
            <div v-if="onlyWebsite" class="add_website" @click="readyAddWebsite()">Add Website</div>
            <!-- 内容 -->
            <div class="lite_popup_content myscroll" v-if="show">
                <!-- 树结构【props：数据属性对应】【load，lazy：异步加载】【expand-on-click-node：点击三角才展开】【show-checkbox：复选框】 -->
                <el-tree class="lite-file-tree" ref="liteTree" node-key="id" :props="props" :load="loadNode" :expand-on-click-node="false" lazy :show-checkbox="showCheckbox" empty-text="">
                    <!-- 自定义树节点 -->
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <!-- 云盘节点，图标用class实现 -->
                        <span v-if="node.level == 1" :class="'drive-icon drive-icon-' + data.icon">{{ data.name }}</span>
                        <!-- 文件夹和文件节点，图标用img实现，如果有没有考虑到的情况使用默认图标 -->
                        <span v-else><img class="node-icon" :src="'/static/file/'+data.icon+'.svg'" @error="e => e.target.src = '/static/file/file.svg'" /><span class="node-name-label">{{ data.name }}</span></span>
                        <span class="more-options">
                            <div v-if="node.next" class="lite_select_more lite_select_next" @click.stop="loadNext(node)"></div>
                            <div v-if="showMkdir(node)" class="lite_select_more lite_select_mkdir" @click.stop="showInputPopup(node)"></div>
                        </span>
                    </span>
                </el-tree>
                <!-- 加载中 -->
                <div class="lite-select-loading" v-show="isLoadDrives"></div>
            </div>
            <!-- 底部 -->
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="selectDone">{{$t('language.common.ok')}}</button>
            </div>
            <!-- 创建文件夹、重命名 -->
            <liteInput ref="inputPopup" :data="input_popup_data" @ok="inputPopupOK" />
            <!-- 添加网站 -->
            <liteAddDrive :auth="auth" @submit="addWebsite()" />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import liteInput from '@/components/workspace/lite_input.vue';
import liteAddDrive from "@/components/workspace/lite_add_drive";
import commonUtils from "@/js/workspace/common_util.js";

export default {
    props: {
        showCheckbox: { type: Boolean, default: true },
        showFileNode: { type: Boolean, default: true },
        showNewFolder: { type: Boolean, default: false },
        showDBDrive: { type: Boolean, default: true },
        showWebsite: { type: Boolean, default: false },
        onlyWebsite: { type: Boolean, default: false },
    },
    components: {
        liteInput,
        liteAddDrive,
    },
    data() {
        return {
            show: false,
            isLoadDrives: false,
            props: {
                // 服务器没有返回label，这里指定用name
                label: 'name',
                // 服务器没有返回isLeaf，但是有dir属性，这里转换一下
                isLeaf: (data) => !data.dir
            },
            // 输入框弹窗
            input_popup_data: {
                type: 'mkdir',
                title: 'New Folder',
                value: '',
                placeholder: 'Please enter folder name',
            },
            // 当前节点
            curNode: null,
            // 添加网站参数准备
            auth: {
                show: false,
                loading: false,
                type: "",
                name: "",
                website: {
                    sites: [],
                    dbs: [],
                },
            },
        };
    },
    methods: {
        isDemoUser() {
            return commonUtils.isDemoUser();
        },
        // 准备添加云盘
        readyAddWebsite() {
            if (this.isDemoUser()) {
                commonUtils.logoutAndJumpToSign();
            } else {
                this.auth.type = "Website";
                this.auth.name = this.addCloudNameInit("Website");
                this.auth.loading = false;
                this.auth.show = true;
            }
        },
        // 添加云盘名称初始化
        addCloudNameInit(name) {
            let names = [];
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                names.push(this.$store.state.drives[i].name);
            }
            // 返回一个不重复的名称，如果有同名就添加数字
            let count = 1;
            let temp = name;
            while (names.indexOf(temp) != -1) {
                temp = name + " " + count;
                count++;
            }
            return temp;
        },
        // 确定添加网站
        addWebsite() {
            if (this.auth.loading) return;
            this.auth.loading = true;
            this.sendRequest("/drive/auth", this.auth, (data) => {
                this.auth.loading = false;
                this.auth.show = false;
                this.loadDrives(() => {
                    const tree = this.$refs.liteTree;
                    tree.root.loaded = false;
                    tree.root.expand();
                    this.$store.state.needLoadDriveInfo = true;
                });
            }, () => {
                this.auth.loading = false;
            });
        },
        showMkdir(node) {
            if (this.showNewFolder) {
                // GoogleDrive
                if (node.level == 1 && node.data.type == 'GoogleDrive') {
                    return false;
                }
                if (node.level == 2 && node.parent.data.type == 'GoogleDrive') {
                    const fileId = node.data.id;
                    if (fileId == 'sharedDrives' || fileId == 'sharedWithMe') {
                        return false;
                    }
                }
                // GoogleWorkspace
                if (node.level == 1 && node.data.type == 'GoogleWorkspace') {
                    return false;
                }
                if (node.level == 2 && node.parent.data.type == 'GoogleWorkspace') {
                    return false;
                }
                if (node.level == 3 && node.parent.parent.data.type == 'GoogleWorkspace') {
                    const fileId = node.data.id;
                    if (fileId == 'sharedDrives' || fileId == 'sharedWithMe') {
                        return false;
                    }
                }
                // MySQL
                if (node.level == 1 && node.data.type == 'MySQL') {
                    return false;
                }
                // Backblaze
                if (node.level == 1 && node.data.type == 'Backblaze') {
                    return false;
                }
                // Website
                if (node.level == 1 && node.data.type == 'Website') {
                    return false;
                }
                if (node.level == 2 && node.parent.data.type == 'Website' && node.data.id.indexOf("MySQL_")==0) {
                    return false;
                }
                return true;
            }
            return false;
        },
        // 新建文件夹弹窗
        showInputPopup(node) {
            this.curNode = node;
            this.$refs.inputPopup.show = true;
            this.input_popup_data.value = '';
        },
        // 输入框弹窗确认
        inputPopupOK() {
            const type = this.input_popup_data.type;
            const name = this.input_popup_data.value;
            if (type === "mkdir") {
                const id = this.getDriveIdFromNode(this.curNode);
                const node = this.getNodeDataFromNode(this.curNode);
                this.mkdir(id, node, name, (data) => {
                    if (this.curNode.expanded) {
                        data.icon = this.getNodeIcon(data);
                        let childNodes = this.curNode.childNodes;
                        if (childNodes.length == 0) {
                            this.$refs.liteTree.append(data, this.curNode);
                        } else {
                            this.$refs.liteTree.insertBefore(data, childNodes[0]);
                        }
                        this.$refs.liteTree.setCurrentNode(data);
                    } else {
                        this.curNode.loaded = false;
                        this.curNode.expand(() => {
                            this.$refs.liteTree.setCurrentNode(data);
                        });
                    }
                });
            }
        },
        // 完成选着
        selectDone() {
            if (this.onlyWebsite) {
                // 勾选选择
                let checkNodes = this.$refs.liteTree.getCheckedNodes(false, false);
                if (checkNodes.length == 0) {
                    return;
                } else {
                    let arr = [];
                    let liteTree = this.$refs.liteTree;
                    for (let i = 0; i < checkNodes.length; i++) {
                        // 这里有个坑，如果不同云盘里面有相同的节点数据信息且都勾选，这里拿到的treeNode始终是最后一个
                        let treeNode = liteTree.getNode(checkNodes[i]);
                        let did = this.getDriveIdFromNode(treeNode);
                        let node = this.getNodeDataFromNode(treeNode);
                        let isExist = false;
                        for (let j = 0; j < arr.length; j++) {
                            if (arr[j].did == did) {
                                // 根节点被勾选过，就不需要往下处理了
                                if (arr[j].node == null) {
                                    isExist = true;
                                    break;
                                }
                                // 当前节点或其父被勾选过，就不需要此节点
                                let tempNode = node;
                                while (tempNode != null) {
                                    if (tempNode == arr[j].node) {
                                        isExist = true;
                                        break;
                                    }
                                    tempNode = tempNode.parent;
                                }
                                if (isExist) {
                                    break;
                                }
                            }
                        }
                        if (!isExist) {
                            arr.push({
                                did: did,
                                node: node,
                            });
                        }
                    }
                    this.$emit('selectDone', arr);
                    this.show = false
                }
            } else {
                // 行选择
                // 选择的云盘ID
                let did = null;
                // 选择的数据节点，包含父的引用
                let node = null;
                // 选择了树节点才有数据
                let serverNode = this.$refs.liteTree.getCurrentNode();
                if (serverNode) {
                    // 选择的树节点
                    let treeNode = this.$refs.liteTree.getNode(serverNode);
                    did = this.getDriveIdFromNode(treeNode);
                    node = this.getNodeDataFromNode(treeNode);
                } else {
                    return;
                }
                // 某些目录禁止作为目标
                const drive = this.getDrive(did);
                const type = drive.type;
                const curNode = node;
                if (type == "GoogleDrive") {
                    if (curNode == null) {
                        Message.warning("If you need to select the root directory, please choose My Drive under Google Drive.");
                        return;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        Message.warning("The current folder is virtual; please select a specific subfolder within it.");
                        return;
                    }
                } else if (type == "GoogleWorkspace") {
                    if (curNode == null) {
                        Message.warning("The current folder is virtual; please select a specific subfolder within it.");
                        return;
                    } else if (curNode.id.indexOf("customer_") == 0) {
                        Message.warning("The current folder is virtual; please select a specific subfolder within it.");
                        return;
                    } else if (curNode.id == "sharedWithMe" || curNode.id == "sharedDrives") {
                        Message.warning("The current folder is virtual; please select a specific subfolder within it.");
                        return;
                    }
                } else if (type == "Backblaze") {
                    if (curNode == null) {
                        Message.warning("The Backblaze root directory contains all buckets; please select a specific bucket or folder.");
                        return;
                    }
                }
                // 取消选择
                this.$refs.liteTree.setCurrentKey(null);
                // 返回数据
                this.$emit('selectDone', {did, node});
                this.show = false
            }
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取文件夹或文件节点图标类型（云盘不用管），这里的node是服务器返回的节点，不是树的节点
        getNodeIcon(node) {
            if (node.dir) {
                if (node.type == "site") {
                    // 站点
                    return "site";
                } else if (node.type == "db") {
                    // 数据库
                    return "db";
                } else {
                    // 文件夹或相簿
                    return "folder";
                }
            } else {
                const index = node.name.lastIndexOf(".");
                if (index == -1) {
                    // 没有后缀的文件
                    return "file";
                } else {
                    const suffix = node.name.substring(index + 1).toLowerCase();
                    if (suffix.length == 0) {
                        // 包含点，但是没有后缀
                        return "file";
                    } else {
                        // 返回文件后缀，不一定靠谱
                        return suffix;
                    }
                }
            }
        },
        // 获取节点的数据，这里的node是树的节点
        getNodeDataFromNode(treeNode) {
            // 选择的数据节点，包含父的引用
            let node = null;
            // 层级数据节点
            let nodes = [];
            // 向上处理
            while (treeNode.level >= 1) {
                if (treeNode.level == 1) {
                    break;
                } else {
                    // 临时存储节点数据
                    if (treeNode.level > 1) {
                        nodes.push(treeNode.data);
                    }
                    // 向上处理
                    treeNode = treeNode.parent;
                }
            }
            // 构建后端需要的数据格式
            if (nodes.length > 0) {
                for (let i = 0; i < nodes.length; i++) {
                    nodes[i].children = null;
                    if (i == nodes.length - 1) {
                        nodes[i].parent = null;
                    } else {
                        nodes[i].parent = nodes[i + 1];
                    }
                }
                node = nodes[0];
            }
            return node;
        },
        // 获取节点的云盘ID，这里的node是树的节点
        getDriveIdFromNode(treeNode) {
            while (treeNode.level >= 1) {
                if (treeNode.level == 1) {
                    // 找到了云盘节点
                    return treeNode.data.id;
                } else {
                    // 往上层找
                    treeNode = treeNode.parent;
                }
            }
        },
        // 异步加载树节点
        loadNode(node, resolve) {
            // 首先展示所有云盘节点
            if (node.level == 0) {
                this.isLoadDrives = true;
                this.loadDrives(() => {
                    this.isLoadDrives = false;
                    let drives = [];
                    this.$store.state.drives.forEach(drive => {
                        // 服务器没有返回dir属性，这里直接赋值
                        drive.dir = true;
                        // 服务器没有返回icon属性，这里使用type属性
                        drive.icon = drive.type;
                        if (this.onlyWebsite) {
                            // 只显示网站
                            if (drive.type == "Website") {
                                drives.push(drive);
                            }
                        } else {
                            // 其他正常显示
                            if (!this.showDBDrive && drive.type == "MySQL") {
                                // 不显示数据库云盘
                            } else if (!this.showWebsite && drive.type == "Website") {
                                // 不显示网站云盘
                            } else {
                                drives.push(drive);
                            }
                        }
                    });
                    if (drives.length == 0 && !this.onlyWebsite) {
                        this.$store.commit('setleftbannerMenuClick', 901);
                        this.$router.push({ path: '/mc_project/add_cloud' });
                    }
                    return resolve(drives);
                });
            }
            // 展开云盘节点
            if (node.level >= 1) {
                // 展开云盘根目录或指定目录
                this.openFolder(this.getDriveIdFromNode(node), (node.level == 1 ? null : node.data), null, (data) => {
                    Vue.set(node, 'next', data.next);
                    let items = [];
                    data.nodes.forEach(item => {
                        // 服务器没有返回icon属性，这里根据名称获取图标类型
                        item.icon = this.getNodeIcon(item);
                        if (!this.showFileNode && !item.dir) {
                            // 不显示文件
                        } else {
                            items.push(item);
                        }
                    });
                    return resolve(items);
                }, () => {
                    // 展开失败的处理
                    node.loaded = false;
                    node.loading = false;
                });
            }
        },
        // 加载下一页
        loadNext(node) {
            node.loading = true;
            this.openFolder(this.getDriveIdFromNode(node), (node.level == 1 ? null : node.data), node.next, (data) => {
                node.loading = false;
                Vue.set(node, 'next', data.next);
                if (node.childNodes.length + data.nodes.length > 1000) {
                    var oldNodes = node.childNodes
                    var liteTree = this.$refs.liteTree;
                    for (var i=oldNodes.length-1; i>=0; i--) {
                        liteTree.remove(oldNodes[i]);
                    }
                    Message.warning("There are too many files, so previously loaded files will no longer be displayed.");
                }
                data.nodes.forEach(item => {
                    // 服务器没有返回icon属性，这里根据名称获取图标类型
                    item.icon = this.getNodeIcon(item);
                    if (!this.showFileNode && !item.dir) {
                        // 不显示文件
                    } else {
                        // 追加下一页的节点
                        this.$refs.liteTree.append(item, node);
                    }
                });
            }, () => {
                node.loading = false;
            });
        },
        // 展开文件夹
        openFolder(id, node, start, callback, errorCallback) {
            if (node && !node.dir) return;
            this.sendRequest("/file/list", { id: id, param: { node: node, start: start } }, callback, errorCallback)
        },
        // 创建文件夹
        mkdir(id, node, name, callback) {
            this.sendRequest("/file/mkdir", { id: id, param: { node: node, name: name } }, (data) => {
                if (callback) {
                    callback(data);
                }
            });
        },
        // 加载云盘
        loadDrives(callback) {
            this.sendRequest("/drive/list", {}, (data) => {
                // 这种方式会导致之前已加载的云盘信息丢失
                // this.$store.state.drives = data;
                // 所以使用下面这种方式
                const drives = this.$store.state.drives || [];
                data.forEach(newItem => {
                    const oldItem = drives.find(d => d.id === newItem.id);
                    if (oldItem) {
                        Object.assign(oldItem, newItem);
                    } else {
                        drives.push(newItem);
                    }
                });
                if (callback) {
                    callback();
                }
            })
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errorCallback) {
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg)
                        if (errorCallback) {
                            errorCallback();
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg)
                            if (errorCallback) {
                                errorCallback();
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    Message.error(err)
                    if (errorCallback) {
                        errorCallback();
                    }
                });
        }
    }
};
</script>

<style scoped>
/* 弹窗宽度 */
.lite_popup_box {
    width: 500px;
}

/* 树的高度控制 */
.lite_tree .lite_popup_content {
    height: 360px;
    overflow: auto;
    position: relative;
    margin-top: 1px;
}

.lite_tree .lite_popup_content>.el-tree {
    padding-left: 0px;
}

/* 树的节点布局 */
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

/* 云盘图标 */
.drive-icon {
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-indent: 35px;
    background-size: 100%;
}

/* 文件夹文件图标 */
.node-icon {
    width: 30px;
    height: 30px;
    margin-right: 4px;
}

/* 节点名称 */
.node-name-label {
    vertical-align: middle;
    max-width: 340px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
}

.more-options {
    height: 20px;
    display: none;
}

.el-tree-node__content:hover .more-options {
    display: inline-block;
}

.lite_select_more {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    display: inline-block;
}

.lite_select_next {
    background-image: url("../../assets/images/vectorImg/icon_next.svg");
}

.lite_select_mkdir {
    background-image: url("../../assets/images/vectorImg/icon_add_floder.svg");
}

/* 加载中 */
.lite-select-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 简洁圆环旋转动画 */
.lite-select-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 添加网站 */
.add_website {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    margin-top: 20px;
    margin-left: 25px;
    padding-left: 30px;
    font-weight: 500;
    color: #5562B4;
    font-size: 14px;
    cursor: pointer;
    background-image: url("../../assets/images/workspace/newNav/add_blue.svg");
    background-position: left center;
    background-repeat: no-repeat;
}

.add_website:hover {
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_select.vue